import { Component, OnInit,ViewChild, ElementRef, Renderer2} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../environments/environment';
import {CartService} from '../services/cart.service';
import {ProductsService} from '../services/products.service';
import {LanguageService} from '../services/language.service';
import { DatePipe, Location } from '@angular/common';
import { HttpClient} from '@angular/common/http';
import { OrderonlineServiceService } from '../services/orderonline-service.service';
import {SiteuserService} from '../services/siteuser.service';

@Component({  
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
  @ViewChild('cmodel') cmodel;
  @ViewChild('closeBtn') closeBtn;

  storedCart = [];
  imgurl:string;
  total: any;
  qty:any;
  totalcartItem:number;
  emptyCoupon:boolean;
  cpnMsg:any; 
  cpnMsg_ar:any; 
  error:string;
  cpnErr:string;
  iscpnErr:boolean;
  iscpnApplied:boolean;
  isLoading:boolean;
  discountedAmount:any;
  finalAmount:any;
  cutlery:string;
  bnrAr:any[]=[];
  productAr:any = [];
  addOns = [];
  varientOpt = [];
  newOpt = [];
  prodQty:number;
  varprice:any;
  finalprice:any;
  addonPrice:any;
  addOnprice:any;
  optionPrice:any;
  optGradient = [];
  multiSelect:number;
  newPrice:any;
  baseprice:any;
  prodId:number;
  priceWithaddon:any;
  pSlug:string;
  catSlug:string;
  prodUrl:string;
  iscustomLoading:boolean;
  isAddonChecked:number;
  test: number;
  showLang:string;
  shopStatus:number;
  cartMsg:string;
  cartMsg_ar:string;
  showGuestCheck:boolean = true;
  nVarientData = [];
  displName:any;
  minQtyMsg: any;
  incVarnt:boolean=true;
  desVarnt:boolean=true;
  isIncQty:boolean=false;
  isDecQty:boolean=false;
  rmId:any;
  newCart: void;

  constructor(private route:ActivatedRoute,
    private el:ElementRef,
    private renderer:Renderer2,
    private srvcart:CartService,
    public datepipe: DatePipe, private location: Location, private langObj:LanguageService,
    private bnrObj:OrderonlineServiceService, private http:HttpClient,
    private srvprod:ProductsService, private suObj:SiteuserService) {
    this.imgurl =  env.imgurl;

    this.langObj.langStr.subscribe((data)=>{
      this.showLang = data;
    });

    this.srvprod.varvalid.subscribe(prodAr=>{
      this.multiSelect = prodAr['multisel'];
      if(this.varientOpt.length > 0 ){
        for(var i=0; i < this.varientOpt.length; i++){
           if(this.multiSelect == 1){
              if(prodAr['pid'] == this.varientOpt[i]['orderitem_id'] && prodAr['optnid'] == this.varientOpt[i]['optionid'] && prodAr['vid'] == this.varientOpt[i]['optvalueid']){   
                this.varientOpt.splice(i, 1);
              }
           }else{
              if(prodAr['pid'] == this.varientOpt[i]['orderitem_id'] && prodAr['optnid'] == this.varientOpt[i]['optionid']){   
                this.varientOpt.splice(i, 1);
              }
           }
           
        }
      }
      this.productTotal(this.addOns, this.varientOpt);
    });


    this.srvprod.ingrdAr.subscribe(ingAr=>{
      if(this.optGradient.length > 0 ){
        for (var i=0;  i < this.optGradient.length; i++) {
          if(ingAr['gradeid'] == this.optGradient[i].ing_id && ingAr['ingvalue'] == this.optGradient[i]['selectedvalue'] ) {
            this.optGradient.splice(i, 1);
          }
        }
      }

    });


    //addon cart edit data 
    
    this.srvprod.adoncartArr.subscribe(adnArr=>{  
     var ac =  this.test++
      if(ac == 0){
        this.addOns = [];
      }
       
      let addonArray = {
        "orderitem_id": adnArr['orderitem_id'],
        "addonname": adnArr['addonname'],
        "addonid": adnArr['addonid'],
        "valuename": adnArr['valuename'],
        "valueid": adnArr['valueid'],
        "addonprice": adnArr['addonprice']
      };

      if(this.addOns.length > 0){
        var isExistAddon = false;
        for (var i=0;  i < this.addOns.length; i++) {
          if(this.addOns[i].valueid == addonArray.valueid) {
            this.addOns[i] = addonArray;
            isExistAddon = true;
            break;    
          }
        }

      }else{
        this.addOns.push(addonArray);
      }
    
      if(isExistAddon == false){
        this.addOns.push(addonArray);
      }

    });

        
    this.srvprod.varientqtyArr.subscribe(prodAr=>{
      this.chkoptvl(prodAr);
    });

  //verients cart edit data 

  this.srvprod.verientcartArr.subscribe(verientArr=>{
    var vc =  this.test++
    if(vc == 0){
      this.varientOpt = [];
    }
    
    let optionArray = {
      "orderitem_id": verientArr['orderitem_id'],
      "optionname": verientArr['optionname'],
      "optionid": verientArr['optionid'],
      "optvaluename": verientArr['optvaluename'],
      "optvalueid": verientArr['optvalueid'],
      "ovprice": verientArr['ovprice']
    };
    
    if(this.varientOpt.length > 0 && this.multiSelect !=1 ){
      var existOpt = false;
      for (var i=0;  i < this.varientOpt.length; i++) {
        if(optionArray.optionid == this.varientOpt[i].optionid && optionArray.optvalueid == this.varientOpt[i].optvalueid ) {
          existOpt = true;
          this.varientOpt[i] = optionArray;
          break;
        }
      }
    }else{
      this.varientOpt.push(optionArray);
    }

    if(existOpt == false){
      this.varientOpt.push(optionArray);
    }
    
  });

   //ingredient cart edit data 

   this.srvprod.ingcartArr.subscribe(ingArr=>{
     var ic =  this.test++
     if(ic == 0){
       this.optGradient = [];
     }

      let gradientArray = {
        'ingName': ingArr['ingName'],
        'ing_id': ingArr['ing_id'],
        'product_id': ingArr['product_id'],
        'selectedvalue': ingArr['selectedvalue']
      }
      
      if(this.optGradient.length > 0 ){
        var existGradient = false;
        for (var i=0;  i < this.optGradient.length; i++) {
          if(gradientArray.ing_id == this.optGradient[i].ing_id && gradientArray['selectedvalue'] == this.optGradient[i]['selectedvalue']) {
            existGradient = true;
            this.optGradient[i] = gradientArray;
            break;
          }
        }

      }else{
        this.optGradient.push(gradientArray);
      }

      if(existGradient == false){
        this.optGradient.push(gradientArray);
      }

    });


  }

  ngOnInit(): void {

    if(this.suObj.loggedIn() == true){
      this.showGuestCheck = false;  
    }


    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.bnrObj.orderOnlineBanner('Cart Page').subscribe((data:any)=>{
      this.bnrAr = data.data[0];
    });

    //get shopclosed status
    this.http.get(env.apiurl+'get-shop-status').subscribe(data=>{
      this.shopStatus = data['status'];
    });

    this.isAddonChecked = 0;
    this.emptyCoupon = false;
    this.cutlery = this.srvcart.chkCutleryAvailable();
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    //console.log(this.storedCart);
    if(this.storedCart != null){
      if(this.storedCart.length > 0){ 
        this.total = 0;

        this.storedCart = this.storedCart.map((nEl) =>{
          this.total = (parseFloat(this.total) + parseFloat(nEl.totalPrice)).toFixed(2);

          if(nEl.varients.length > 0){
            let tVar = [];
            tVar = nEl.varients.reduce(function (r, a) {
              r[a.optionname] = r[a.optionname] || [];
              r[a.optionname].push(a);
              return r;
            }, Object.create(null));

            let arrays = [];
            for (var key in tVar) {arrays.push(tVar[key]);}
            nEl['newVariant'] = arrays;
          }
          
          return nEl;
        });
      }else{
        localStorage.removeItem('cartData');
      }
    }

    this.getFinalAmount(this.total);
    
  }

  removeCart(id){
    //console.log(id);
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(this.storedCart.length == 1){
      localStorage.removeItem('cartData');
      this.storedCart = null;
      this.totalcartItem = 0;
      this.srvcart.cartCount.emit(this.totalcartItem);
      return;
    }
    
    this.storedCart.splice(id, 1);
    if(this.storedCart.length > 0){
      this.total = 0;
      for(var i=0; i < this.storedCart.length; i++ ){
        this.total = (parseFloat(this.total) + parseFloat(this.storedCart[i].totalPrice)).toFixed(2);
      }
    }
   
    localStorage.setItem("cartData", JSON.stringify(this.storedCart));
    // Block to send cart count to header
    var storedCart = JSON.parse(localStorage.getItem("cartData"));
    this.totalcartItem = storedCart.length;
    this.srvcart.cartCount.emit(this.totalcartItem);

    this.removeCoupon();
    this.getFinalAmount(this.total);
    location.reload();
  }

  calulatePrice(qty,price,prodId){
    var subTotal = (qty * parseFloat(price)).toFixed(2);
    for(var i=0; i < this.storedCart.length; i++ ){
      if(this.storedCart[i].pId == prodId){
      var subTotal = (qty * parseFloat(price)).toFixed(2);
        this.storedCart[i].totalPrice = subTotal;
        this.storedCart[i].qty = qty;
        this.total = (parseFloat(this.total) + parseFloat(price)).toFixed(2);
        localStorage.setItem("cartData", JSON.stringify(this.storedCart));  
      }
    }
  }

  incQty(qty,prodId,price,varient=null,addon=null,sno){
    this.incVarnt = true;
    this.isIncQty = true;
    this.qty = parseInt(qty) + 1;
    for(var i=0; i < this.storedCart.length; i++ ){
      if(this.storedCart[i].pId == prodId){

        if(this.storedCart[i].parentCatid == 19){
          if(this.storedCart[i].avlpQty != null){
            if(this.qty > this.storedCart[i].avlpQty){
              this.cartMsg = "Please select fewer quantity and try.";
              this.cmodel.nativeElement.click();
              setTimeout (() => {this.closeBtn.nativeElement.click();}, 4000);
              return;
            }
          }
          
        }

        
        if(this.storedCart[i].varients.length > 0){
          if(this.storedCart[i].varients[0].optvalueid){
            if(varient.length > 0){
              this.incVarnt = false;
              if(this.storedCart[i].varients[0].optvalueid == varient[0].optvalueid){
                if(this.storedCart[i].sno == sno){
                    var subTotal = (this.qty * parseFloat(price)).toFixed(2);
                    this.storedCart[i].totalPrice = subTotal;
                    this.storedCart[i].qty = this.qty;
                    this.total = (parseFloat(this.total) + parseFloat(price)).toFixed(2);
                    localStorage.setItem("cartData", JSON.stringify(this.storedCart));
                    
                }
                
              }
              
            }
          }
          

        }else if(this.storedCart[i].addons.length > 0){
          if(this.storedCart[i].addons[0].valueid){
            if(addon.length > 0){
              if(this.storedCart[i].addons[0].valueid == addon[0].valueid){
                if(this.storedCart[i].sno == sno){
                  var subTotal = (this.qty * parseFloat(price)).toFixed(2);
                  this.storedCart[i].totalPrice = subTotal;
                  this.storedCart[i].qty = this.qty;
                  this.total = (parseFloat(this.total) + parseFloat(price)).toFixed(2);
                  localStorage.setItem("cartData", JSON.stringify(this.storedCart));
                }
              }
            }
          }

        }else{
          if(this.incVarnt){
          var subTotal = (this.qty * parseFloat(price)).toFixed(2);
          this.storedCart[i].totalPrice = subTotal;
          this.storedCart[i].qty = this.qty;
          this.total = (parseFloat(this.total) + parseFloat(price)).toFixed(2);
          localStorage.setItem("cartData", JSON.stringify(this.storedCart));
          this.newCart = localStorage.setItem('cart',JSON.stringify(this.storedCart.length))  
          }
          
        }

       
        
      }
    }

    this.removeCoupon();
    this.getFinalAmount(this.total);
  }

  desQty(qty,prodId,price,varient=null,addon=null,sno){ 
    this.isDecQty = true;
    this.desVarnt = true;
    this.qty = qty;
    if(this.qty > 1){
      this.qty = parseInt(qty) - 1;
    }else{
      this.qty = 1;
      for (var i = 0; i < this.storedCart.length; i++) {
        
        if (this.storedCart[i].pId === prodId) {
          if(this.storedCart[i].varients.length > 0){
            if(this.storedCart[i].varients[0].optvalueid){
              if(varient.length > 0){
                this.desVarnt = false;
                if(this.storedCart[i].sno == sno){
                  if(this.storedCart[i].varients[0].optvalueid == varient[0].optvalueid){
                    this.storedCart.splice(i, 1);  
                  }
                }
                
              }
              
            }
            
          }else if(this.storedCart[i].addons.length > 0){
            //console.log('yes inside the add');
            if(this.storedCart[i].addons[0].valueid){
              if(addon.length > 0){
                this.desVarnt = false;
                if(this.storedCart[i].sno == sno){
                  if(this.storedCart[i].addons[0].valueid == addon[0].valueid){
                    this.storedCart.splice(i, 1);
                  }
                }
                
              }
            }
  
          }else{
            if(this.desVarnt){
              this.storedCart.splice(i, 1);
              window.location.reload();
            }
            
          }
          
        }
      }
      
      localStorage.setItem("cartData", JSON.stringify(this.storedCart));
      this.getFinalAmount(this.total); 
      return false;
    }


    for (var i = 0; i < this.storedCart.length; i++) {
      if (this.storedCart[i].pId == prodId) {
          if(this.storedCart[i].varients.length > 0){ 
            if(this.storedCart[i].varients[0].optvalueid){
              if(varient.length > 0){
                this.desVarnt = false;
                if(this.storedCart[i].varients[0].optvalueid == varient[0].optvalueid){
                  if(this.storedCart[i].sno == sno){
                    var subTotal = (this.qty * parseFloat(price)).toFixed(2);
                    this.storedCart[i].totalPrice = subTotal;
                    this.storedCart[i].qty = this.qty;
                    this.total = (parseFloat(this.total) - parseFloat(price)).toFixed(2);
                    localStorage.setItem("cartData", JSON.stringify(this.storedCart));
                    this.getFinalAmount(this.total);
                  }
                  
                }
              }
              
            }
            
          }else if(this.storedCart[i].addons.length > 0){
            if(this.storedCart[i].addons[0].valueid){
              if(addon.length > 0){
                this.desVarnt = false;
                if(this.storedCart[i].addons[0].valueid == addon[0].valueid){
                  if(this.storedCart[i].sno == sno){
                    var subTotal = (this.qty * parseFloat(price)).toFixed(2);
                    this.storedCart[i].totalPrice = subTotal;
                    this.storedCart[i].qty = this.qty;
                    this.total = (parseFloat(this.total) - parseFloat(price)).toFixed(2);
                    localStorage.setItem("cartData", JSON.stringify(this.storedCart));
                    this.getFinalAmount(this.total);
                  }
                }
              }
            }
          }else{
            if(this.desVarnt){
              var subTotal = (this.qty * parseFloat(price)).toFixed(2);
              this.storedCart[i].totalPrice = subTotal;
              this.storedCart[i].qty = this.qty;
              this.total = (parseFloat(this.total) - parseFloat(price)).toFixed(2);
              localStorage.setItem("cartData", JSON.stringify(this.storedCart));
              this.newCart = localStorage.setItem('cart',JSON.stringify(this.storedCart.length))
              this.getFinalAmount(this.total);
            }
            
          }

      }
    }

    this.removeCoupon();
    ///console.log(this.finalAmount);
    this.getFinalAmount(this.total);
  }

  applyCoupon(cpcode){

    const cartarr = this.storedCart.map((nEl) =>{
      return {id:nEl.pId, price:nEl.totalPrice};
    });

    // const cartarr =[];

    if(cpcode !=''){
        this.isLoading = true;
        let userid = null;  
        if(!this.suObj.loggedIn() == false){
           userid = this.suObj.getLoggedinId();  
        }
        
        this.srvcart.applyCoupon(cpcode, userid, cartarr).subscribe(data => {
          // console.log(data);
          this.isLoading = false;
          if(data['success']){
            var expDate = data['data']['ExpireDate'];
            var minOrderAmt = parseFloat(data['data']['minOrderAmount']);
            let totalDiscount = data['totalDiscount'];
            let productApply = data['productApply'];
            
            var currentDate =  this.datepipe.transform(new Date(), 'yyyy-MM-dd');
            if(currentDate > expDate ){
              this.iscpnApplied = false;
              this.cpnMsg="This coupon has been expired.";
              this.cpnMsg_ar="هذه القسيمة قد انتهت صلاحيتها.";
            }else{
              if(this.total >=  minOrderAmt){
                  this.discountedAmount = totalDiscount; //Discount Amount
                  this.addDiscount(this.discountedAmount, cpcode);
                  this.finalAmount = this.total -this.discountedAmount;
                  this.iscpnApplied = true;
                  
                  if(productApply > 1){
                    this.cpnMsg="Coupon has been applied on "+ productApply +" items.";
                    this.cpnMsg_ar="بنود"+" "+ productApply +" "+"تم ثطبيق الحصم على";
                  }else{
                    this.cpnMsg="Coupon has been applied.";
                    this.cpnMsg_ar="تم ثطبيق الحصم";
                  }
                }else{
                this.iscpnApplied = false;
                this.cpnMsg="Your minimum order should be AED "+minOrderAmt;
                this.cpnMsg_ar="يجب أن يكون الحد الأدنى للطلب الخاص بك "+minOrderAmt;
              }
            }
          }else{
            this.iscpnApplied = false;
            this.cpnMsg=data['data'];
            this.cpnMsg_ar=data['data_ar'];
          }
        },error=> {error.message;});
    }else{
      this.iscpnApplied = false;
      this.cpnMsg="Enter coupon code";
      this.cpnMsg_ar="أدخل رمز القسيمة";
    }
  }


  addDiscount(amt, cpncode){
    var amts = parseFloat(amt).toFixed(2);
    sessionStorage.setItem("sjcartdcnt", amts);
    sessionStorage.setItem("sjcpncode", cpncode);
  }

  removeCoupon(){
    sessionStorage.removeItem('sjcartdcnt');
    sessionStorage.removeItem("sjcpncode");
    this.discountedAmount = false;
  }

  getDiscount(){
    if (localStorage.getItem("sjcartdcnt") != null) {
      this.discountedAmount = parseFloat(localStorage.getItem("sjcartdcnt")).toFixed(2);
    }
    
  }

  getFinalAmount(total:number){
    this.finalAmount = total;
    if (localStorage.getItem("sjcartdcnt") != null) {
      this.discountedAmount = parseFloat(localStorage.getItem("sjcartdcnt")).toFixed(2);
      this.finalAmount = total-this.discountedAmount;
    }

    this.finalAmount = parseFloat(this.finalAmount).toFixed(2);
  }

  
  onCutleryCheck(cutval:string){
    localStorage.setItem("sjcutlery", cutval);
  }

  goBackPage(){
    this.location.back();
  }

//customize cart code strat here

customize(pslug, catslug, qty, prodId, priceWithaddon, produrl){
  this.test = 0;
  this.qty = qty;
  this.prodId = prodId;
  this.finalprice = (priceWithaddon * qty).toFixed(2);
  this.priceWithaddon = priceWithaddon; 
  this.pSlug = pslug;
  this.catSlug = catslug;
  this.prodUrl = produrl;

  this.srvprod.getProductSlug(pslug, catslug).subscribe(data => {   
    this.isLoading = false;
    this.productAr = data['data'];
     this.baseprice = this.productAr.price;
  },error=> {this.error  = error.message;});

}

chkadonvl(e){
  var amt = e.value;
  var addonName = e.getAttribute('adonName');
  var adonId = e.getAttribute('adonid');
  var valueName = e.getAttribute('valuename');
  var valueId = e.getAttribute('valueid');
  var productId = e.getAttribute('pid');
  var addonPrice = e.value;
  var addonQty = e.getAttribute('qty');
  this.prodQty = addonQty;
  
  let addonArray = {
    "orderitem_id": productId,
    "addonname": addonName,
    "addonid": adonId,
    "valuename": valueName,
    "valueid": valueId,
    "addonprice": addonPrice
  };


  if(e.checked){
    this.addOns.push(addonArray);
  }else{
    for (var i=0;  i < this.addOns.length; i++) {
        if(addonArray.valueid == this.addOns[i].valueid) {
          this.addOns.splice(i, 1);
        }
    }
  }
  
  this.productTotal(this.addOns, this.varientOpt);
  
}

optionValueTtl(){
  this.varientOpt = [];
  let selctchk = this.el.nativeElement.querySelectorAll('.optnchk:checked');
  
  for (const rb of selctchk) {    
    let optionname = rb.getAttribute('optnname');
    let optionname_ar = rb.getAttribute('optnname_ar');
    let optionid = rb.getAttribute('optnid');
    let optvaluename = rb.getAttribute('optnvalue');
    let optvaluename_ar = rb.getAttribute('optnvalue_ar');
    let productId = rb.getAttribute('pid');
    let optPrice = rb.getAttribute('price');
    let ovQty = rb.getAttribute('qty');
    this.prodQty = rb.getAttribute('qty');
    let optvalueid = rb.value;
    this.multiSelect = rb.getAttribute('multisel');
  
    let optionArray = {
      "orderitem_id": productId,
      "optionname": optionname,
      "optionname_ar": optionname_ar,
      "optionid": optionid,
      "optvaluename": optvaluename,
      "optvaluename_ar": optvaluename_ar,
      "optvalueid": optvalueid,
      "ovprice": optPrice,
      "ovqty":ovQty
    };
    this.varientOpt.push(optionArray);
  }
    
  this.productTotal(this.addOns, this.varientOpt);
}


chkoptvl(e) {
  this.optionValueTtl();
}



productTotal(addOn, option){
  //console.log(option);

  if(addOn != ''){
    this.addOnprice = 0;
    for(var i=0; i < addOn.length; i++){
     this.addOnprice = (parseFloat(this.addOnprice) + parseFloat(addOn[i]['addonprice'])).toFixed(2);
    }
  }else{
    this.addOnprice = 0;
  }

  if(option != ''){
    this.optionPrice = 0;
    for(var j=0; j < option.length; j++){
     if(option[j]['ovqty'] == undefined){
        option[j]['ovqty'] = 0;
     }
     
     this.optionPrice = (parseFloat(this.optionPrice) + (parseFloat(option[j]['ovprice']) * parseFloat(option[j]['ovqty']))).toFixed(2);
    }
  }else{
    this.optionPrice = 0;
  }
  this.newPrice = (parseFloat(this.baseprice) + parseFloat(this.addOnprice) + parseFloat(this.optionPrice)).toFixed(2);
  
  this.finalprice = (this.newPrice * this.qty).toFixed(2);

}

checkGradient(e){
  var gradeName = e.getAttribute('gradeName');
  var gradeId = e.getAttribute('gradeid');
  var productId = e.getAttribute('pid');
  var slectedVal = e.value;
  let gradientArray = {
    'ingName': gradeName,
    'ing_id': gradeId,
    'product_id': productId,
    'selectedvalue': slectedVal
  }
  
  if(this.optGradient.length > 0 ){
    var existGradient = false;
    for (var i=0;  i < this.optGradient.length; i++) {
      if(gradientArray.ing_id == this.optGradient[i].ing_id) {
        existGradient = true;
        this.optGradient[i] = gradientArray;
        break;
      }
    }
  }else{
    this.optGradient.push(gradientArray);
  }

  if(existGradient == false){
    this.optGradient.push(gradientArray);
  }

}


incQtyModel(qty,price, parentCatid, avlbQty){
  //console.log(price);

  this.qty = parseInt(qty) + 1;
    if(parentCatid == 19 && avlbQty != null){
      if(this.qty > avlbQty){
        this.qty = parseInt(qty);
        this.cartMsg = "Please select fewer quantity and try.";
        this.cmodel.nativeElement.click();
        setTimeout (() => {this.closeBtn.nativeElement.click();}, 4000);
        return;
        
      }
    }

    if(this.addOns.length > 0 || this.varientOpt.length > 0){
      this.productTotal(this.addOns, this.varientOpt)
    }else{
      this.finalprice = (this.qty * parseFloat(price)).toFixed(2);
    }
}

desQtyModel(qty,price){
  if(qty > 0){
    if(qty == 1){
      if(this.addOns.length > 0 || this.varientOpt.length > 0){
        this.productTotal(this.addOns, this.varientOpt)
      }else{
        this.finalprice = parseFloat(price).toFixed(2);
      }
      
    }else{
      this.qty = parseInt(qty) - 1;
      if(this.addOns.length > 0 || this.varientOpt.length > 0){
        this.productTotal(this.addOns, this.varientOpt)
      }else{
        this.finalprice = ((qty * parseFloat(price)) - parseFloat(price) ).toFixed(2);
      }
      
    }
  }
}

saveCustomization(prod,id,price,finalprice,qty,image){

  for (let index = 0; index < this.productAr.poptions.length; index++) {
    const optn = this.productAr.poptions[index];
    if (optn.isRestricted == 1) {
      let totalQty = 0;
      this.varientOpt.map((nEl) =>{  
        if(nEl.optionid == optn.id){
          totalQty =  totalQty+parseInt(nEl.ovqty);
        }
      });
            
      if (totalQty != optn.qnty) {
        this.displName = optn.option_display_name;
        this.minQtyMsg = `Please select ${optn.qnty} quantity from ${optn.option_display_name}`
         //this.minQtyMsg = `Please select ${optn.qnty} quantity`
        return
      }

    }
  }


  this.iscustomLoading = true;
  var priceWithaddon = (parseFloat(finalprice) / qty ).toFixed(2);
  let prodArray = {
    "pName": prod,
    "pId": id,
    "pslug":this.pSlug,
    "catslug":this.catSlug,
    "pImage": image,
    'pUrl': this.prodUrl,
    "basePrice": price,
    "totalPrice": finalprice,
    "priceWithaddon": priceWithaddon,
    "qty": qty,
    "addons": this.addOns,
    "varients": this.varientOpt,
    "ingradients": this.optGradient
  };

  this.storedCart = JSON.parse(localStorage.getItem("cartData"));
  if(this.storedCart != null && this.storedCart.length > 0){
    for(var i=0; i < this.storedCart.length; i++){
      if(this.storedCart[i].pId == prodArray.pId){
        this.storedCart[i]= prodArray;
      }
    }
    localStorage.setItem("cartData", JSON.stringify(this.storedCart));
  }
  location.reload();
}


}